import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import { myLayout, myStyle, filaColSpanObj, filaColSpanText, filaVacia, retornaArrayAncho, ponHeaderTabla, resuelveFila, resuelveFilaComplejo } from "./reportUtils";

import imageToBase64 from 'image-to-base64/browser';
import { configure } from "@testing-library/react";
import { extendUint8Array } from "js-base64";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const BROWN = "#8D643B"
const BLUE = "#2B599F"

/* formato va a ser 
    {
        pageSize : "A4",
        pageOrientation : "portrait" o "landscape"
        pageMargins : [ 20, 20, 20, 20],
        columnas : 1 o 2, // según sea el informe
        alineación : justify,
    }

    datos va a ser
    {
        title : "Informe de caraconos",
        author:
        subject : "descripción del informe",
        keywords : "metapalabras si las hubiere"
        datos : colección de datos del informe
        titulosTabla:
        origen: Congregación, Provincia, Comunidad
        tipoInforme: Fotos, Listado simple, Listado complejo
    }    
*/

export const reportWritePdf = async (
    descargar = true,
    datos = {
        title: "Informe STJ",
        author: "Congregación STJ",
        subject: "Informe STJ",
        keywords: "Informe STJ",
        datos: [],
        titulosTabla: [],
        tipoInforme: 'Listado simple',
        columnasApi: [],
        titulosComplejo:{
            headerComplejo: [],
            columnasApi: []
        }
    },
    formato = {
        pageSize: "A4",
        pageOrientation: "portrait",
        pageMargins: [20, 40, 20, 20],
        columnas: 1,
        alineacion: "justify",
        origen: "Congregación",
    },

) => {

    if(datos.datos.length === 0){
        alert('El informe arroja datos. Compruebe su existencia en la base de datos')
    }else{

    
    
    //INICIALIZACIONES DE LOGOS
    const logoCongregacion = await imageToBase64('images/logoSTJ.png')
        .then((response) => { return response })
    const logoFet = await imageToBase64('images/logoFET.png')
        .then((response) => { return response })
    const logoMta = await imageToBase64('images/logoMTA.png')
        .then((response) => { return response })
    const logoFundeo = await imageToBase64('images/logoFUNDEO.png')
        .then((response) => { return response })


    //////////////////////////////////////////////////////////////////////////////MOTAJE DE INFORME
    const docDefinition = {

        info: {
            title: datos.title,
            author: datos.author,
            subject: datos.subject,
            keywords: datos.keywords,
        },

        font: "https://fonts.googleapis.com/css?family=Comfortaa",
        pageSize: formato.pageSize,
        pageOrientation: formato.pageOrientation,
        pageMargins: formato.pageMargins,

        // HEADER #########################################################################################
        header: {
            columns: [
                {
                    image: 'data:image/jpeg;base64,' + logoCongregacion,
                    width: 100,
                    height: 40,
                    margin: [20, 15, 30, 10]
                },
                {
                    text: datos.title,
                    alignment: 'center',
                    margin: [20,20],
                    style: ['h3', 'c2', 'w1'],
                },
                {
                    alignment: 'right',
                    width: '30%',
                    text: "Impresión: " + new Date().toJSON().slice(0, 10)
                        + " " + new Date().toJSON().slice(11, 16),
                    style: ['h6', 'c2', 'w1'],
                    margin: [20, 15, 20, 10]
                },
            ],
        },
        // FOOTER #########################################################################################

        footer: function (currentPage, pageCount, pageSize) {
            // you can apply any logic and return any valid pdfmake element

            return [
                {
                    columns: [{
                        text: currentPage.toString() + ' de ' + pageCount,
                        alignment: (currentPage % 2) ? 'left' : 'right',
                        margin: (currentPage % 2) ? [20, 10, 1, 10] : [1, 10, 20, 10],
                        style: ['h4', 'c2', 'w1'],
                    },
                    {
                        text: datos.title,
                        alignment: 'center',
                        style: ['h5', 'c2', 'w1'],
                        margin: [20, -10, 20, 10],
                    },
                    ],
                },
            ]
        },

        // BACKGROUND#########################################################################################
        background: function (currentPage, pageSize) {
            console.log(currentPage)
            console.log(pageSize)
            return [
                {
                    canvas: [
                        { type: 'line', x1: 5, y1: 5, x2: 590, y2: 5, lineWidth: 0.5, color: BROWN }, //Up line
                        { type: 'line', x1: 5, y1: 5, x2: 5, y2: 835, lineWidth: 0.5, color: BROWN }, //Left line
                        { type: 'line', x1: 5, y1: 835, x2: 590, y2: 835, lineWidth: 0.5, color: BROWN }, //Bottom line
                        { type: 'line', x1: 590, y1: 5, x2: 590, y2: 835, lineWidth: 0.5, color: BROWN }, //Rigth line
                    ]

                }
            ]
        },

        // CONTENIDO #########################################################################################

        content: [
            //llamo a una función que me va a devolver la tabla completa correcta
            await lanzaInforme(datos, 5, 100, '%', logoCongregacion, datos.tipoInforme),

        ],

        // DEFAULT STYLE#####################################################################################
        defaultStyle: {
            fontSize: 10,
            bold: false,
            italics: false,
            alignment: 'left',
            /*characterSpacing: number: size of the letter spacing in pt
            color: string: the color of the text (color name e.g., ‘blue’ or hexadecimal color e.g., ‘#ff5500’)
            background: string the background color of the text
            markerColor: string: the color of the bullets in a buletted list
            decoration: string: the text decoration to apply (‘underline’ or ‘lineThrough’ or ‘overline’)
            decorationStyle: string: the style of the text decoration (‘dashed’ or ‘dotted’ or ‘double’ or ‘wavy’)
            decorationColor: string: the color of the text decoration, see color
            font: string: name of the font
            fontSize: number: size of the font in pt
            fontFeatures: string[]: array of advanced typographic features supported in TTF fonts (supported features depend on font file)
            lineHeight: number: the line height (default: 1)*/
        },

        // IMÁGENES #########################################################################################

        //precarga de imagenes a través de llamadas a api o lo que sea
        images: {
            // in browser is supported loading images via url (https or http protocol) (minimal version: 0.1.67)
            //logoCongregacion: 'https://idesi.net/images/logowebnueva.png',

            //monja: 'http://localhost:5000/download/provincias/6/comunidades/1',

            // is supported loading images via url with custom headers (minimal version: 0.2.5)
            /* 
            strawberries: {
                url: 'https://picsum.photos/id/1080/100/100',
                headers: {
                    myheader: '123',
                    myotherheader: 'abc',
                }
            }
            */
        },
        styles: myStyle,
    };

    //descargar o mostrar en navegador
    if (datos.descargar) {
        pdfMake.createPdf(docDefinition).download(`${datos.title}.pdf`)
    } else {
        try {
            pdfMake.createPdf(docDefinition).open(window)
        } catch (err) {
            alert('Tiene activado el bloqueador de emergentes. Desactívelo y lance de nuevo el informe');
        }

    }
    }
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const lanzaInforme = async (datos, noColumnas, ancho, porcentaje, logo, tipoInforme) => {
    console.log('tipo informe: ' + tipoInforme)
    switch (tipoInforme) {
        case 'Fotos': return await lanzaInformeFotos(datos, noColumnas, ancho, porcentaje, logo)
        case 'Listado simple': return await lanzaInformeListadoSimple(datos, noColumnas, ancho, porcentaje, logo)
        case 'Listado complejo': return await lanzaInformeListadoComplejo(datos, noColumnas, ancho, porcentaje, logo)
        case 'Listado complejo detalle': return await lanzaInformeListadoComplejoDetalle(datos, noColumnas, ancho, porcentaje, logo)
        case 'Listado detalle hermana': return await lanzaInformeDetalleHermanas(datos, noColumnas, ancho, porcentaje, logo)
        default:
    }

}
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

///---------------------------------------------------------------------------------------1. FOTOS
//FUNCION PARA ADAPTAR LOS DATOS A TABLA EN COLUMNAS DE noColumnas
const adaptaDatosTablaFotos = async (datos, noColumnas, filasAMontar) => {
    let conFilaAuxiliar = 0
    let noIteraciones = 0   //elementos de los tuplas
    let noPackColumnas = 0
    let indiceTablaAdaptada = 0  //contador filas de tabla Adaptada final
    //elementos de la tabla
    let banderaSaltoPagina = false

    let fila = []   //fila de tabla final fotos
    let fila2 = []  //fila de tabla final nombre
    let fila3 = []  //fila de tabla final apellidos
    let tablaAdaptada = [] //tabla final a devolver para mostrar en

    //control de comunidad

    for (let n = 0; n < datos.length; n++) {
        if(banderaSaltoPagina){
            //linea horizontal en la primera página no
            //tablaAdaptada[indiceTablaAdaptada] = filaColSpanObj(noColumnas, noColumnas, { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 545, y2: 0, lineWidth: 2, color: 'black' }] })
            //indiceTablaAdaptada++
        }
        //linea horizontal
        //tablaAdaptada[indiceTablaAdaptada] = filaColSpanObj(noColumnas, noColumnas, { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 0.5 }] })
        //indiceTablaAdaptada++
        //titulo de la comunidad
        tablaAdaptada[indiceTablaAdaptada] = filaColSpanText(noColumnas, noColumnas, datos[n].communityName ? `${datos[n].provinceName} - ${datos[n].communityName}` : '', banderaSaltoPagina)
        indiceTablaAdaptada++
        //linea horizontal
        tablaAdaptada[indiceTablaAdaptada] = filaColSpanObj(noColumnas, noColumnas, { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 300, y2: 0, lineWidth: 0.5, color: BLUE }] })
        indiceTablaAdaptada++
        //linea vacia
        tablaAdaptada[indiceTablaAdaptada] = filaVacia(noColumnas)
        indiceTablaAdaptada++
        //solo para la primera entrada
        banderaSaltoPagina = false
        //calculo el no de iteraciones que voy a realizar

        if (datos[n].contador % noColumnas === 0) {
            //si el resto es 0 es el contador de elementos que tiene el array
            noIteraciones = datos[n].contador
        } else {
            //si no tengo que añadir a los elementos la diferencia del numero de columans y el resto de la division
            noIteraciones = datos[n].contador + noColumnas - (datos[n].contador % noColumnas)
        }

        for (let k = 0; k < noIteraciones; k++) {
            //recorro la subdata con y guardo en la tabla los valores

            if (datos[n].tuplas[k]) {
                //hay elemento en la tupla

                fila[conFilaAuxiliar] = {
                    image: 'data:image/jpeg;base64,' + datos[n].tuplas[k].fotico,
                    fit: [100, 100],
                    //width: 150,
                    //height: 150,
                    //margin: [20, 15, 20, 10],
                    style: ['center']
                }
                //nombre
                fila2[conFilaAuxiliar] = { 'text': `${datos[n].tuplas[k].userName}`, style: ['h4', 'fazul', 'bold', 'cwhite', 'center'] }
                //algo más
                fila3[conFilaAuxiliar] = { 'text': `${datos[n].tuplas[k].apell1} ${datos[n].tuplas[k].apell2}`, style: ['h5', 'fazul', 'bold', 'cwhite', 'center'] }
            } else {
                fila[conFilaAuxiliar] = { 'text': '' }
                fila2[conFilaAuxiliar] = { 'text': '' }
                fila3[conFilaAuxiliar] = { 'text': '' }
            }
            conFilaAuxiliar++
        }

        for (let j = 0; j < (noIteraciones / noColumnas); j++) {

            tablaAdaptada[indiceTablaAdaptada] = fila.slice(noColumnas * noPackColumnas, (noColumnas * noPackColumnas) + noColumnas)
            indiceTablaAdaptada++
            tablaAdaptada[indiceTablaAdaptada] = fila2.slice(noColumnas * noPackColumnas, (noColumnas * noPackColumnas) + noColumnas)
            indiceTablaAdaptada++
            tablaAdaptada[indiceTablaAdaptada] = fila3.slice(noColumnas * noPackColumnas, (noColumnas * noPackColumnas) + noColumnas)
            indiceTablaAdaptada++

            noPackColumnas++ //valor para calcular el subarray de la subtabla fila que hay q poner en cada fila 
        }

        //aqúi podemos poner la separación entre comunidades
         //linea horizontal en la primera página no
         tablaAdaptada[indiceTablaAdaptada] = filaColSpanObj(noColumnas, noColumnas, { canvas: [{ type: 'line', x1: 0, y1: 10, x2: 545, y2: 0, lineWidth: 1.5, color: 'white' }] })
         indiceTablaAdaptada++
         tablaAdaptada[indiceTablaAdaptada] = filaColSpanObj(noColumnas, noColumnas, { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 545, y2: 0, lineWidth: 1, color: BROWN }] })
         indiceTablaAdaptada++
         tablaAdaptada[indiceTablaAdaptada] = filaColSpanObj(noColumnas, noColumnas, { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 545, y2: 0, lineWidth: 1, color: BROWN }] })
         indiceTablaAdaptada++
         tablaAdaptada[indiceTablaAdaptada] = filaColSpanObj(noColumnas, noColumnas, { canvas: [{ type: 'line', x1: 0, y1: 10, x2: 545, y2: 0, lineWidth: 1.5, color: 'white' }] })
         indiceTablaAdaptada++
         
    }
    return tablaAdaptada
}
///--------------------------------------------------------------------------------------1.2 FOTOS
//FUNCIÓN PRINCIPAL TABLA DATOS TIPO FOTO
const lanzaInformeFotos = async (datos, noColumnas, ancho, porcentaje, logo) => {
    let filas = await adaptaDatosTablaFotos(datos.datos, noColumnas, ['photo', 'Nombre', 'Cargo',])
    return {
        layout: 'headerLineOnly',
        style: ['m10'],
        table: {
            headerRows: 0,
            widths: retornaArrayAncho(noColumnas, ancho, porcentaje), //["20%", "20%", "20%", "20%", "20%"," 20%",], //'*', 'auto', '30%'],//, 100, '*' ],
            body:
                [
                    /*[{ text: '11' , colSpan: 5}, {text:''}, {text:''}, {text:''}, {text:''}],*/
                    //filaColSpan(noColumnas,noColumnas, 'Título a poner de la comunidad', false),
                    //filaVacia(noColumnas),
                    //...header,
                    /*  [{text: 'Concepto', style: ['h5', 'fc11', 'cb']},{text: item.text, style: ['h4', 'fc2', 'b', 'c2']}],*/
                    ...filas,
                ]
        },
    }
}

///--------------------------------------------------------------------------------------2. SIMPLE
//FUNCION PARA ADAPTAR LOS DATOS A TABLA EN COLUMNAS DE noColumnas
const adaptaDatosTablaListadoSimple = async (datos, noColumnas, titulosTabla, columnasApi) => {
    let tablaAdaptada = [] //tabla final a devolver para mostrar en
    for (const dato of datos) {
        tablaAdaptada.push(resuelveFila(dato, columnasApi))
    }
    return tablaAdaptada
}
///-------------------------------------------------------------------------------------2.2 SIMPLE
//FUNCIÓN PRINCIPAL TABLA DATOS TIPO LISTADO SIMPLE
const lanzaInformeListadoSimple = async (datos, noColumnas, ancho, porcentaje, logo) => {
    //el número de columnas lo da la longitud del array de titulosTabla
    let filas = await adaptaDatosTablaListadoSimple(datos.datos, datos.titulosTabla.length, datos.titulosTabla, datos.columnasApi)
    return {
        layout: 'lightHorizontalLines',
        style: ['m10', 'h5'],
        table: {
            headerRows: 1,
            widths: retornaArrayAncho(datos.titulosTabla.length, ancho, porcentaje, true), //["20%", "20%", "20%", "20%", "20%"," 20%",], //'*', 'auto', '30%'],//, 100, '*' ],
            body:
                [
                    //[{ text: '11' , colSpan: 5}, {text:''}, {text:''}, {text:''}, {text:''}],
                    ponHeaderTabla(datos.titulosTabla.length, datos.titulosTabla),
                    //filaColSpan(noColumnas,noColumnas, 'Título a poner de la comunidad', false),
                    //filaVacia(noColumnas),
                    //...header,
                    /*  [{text: 'Concepto', style: ['h5', 'fc11', 'cb']},{text: item.text, style: ['h4', 'fc2', 'b', 'c2']}],*/
                    ...filas,
                ]
        },
    }
}



///-------------------------------------------------------------------------------------3. COMPLEJO
//FUNCION PARA ADAPTAR LOS DATOS A TABLA EN COLUMNAS DE noColumnas
const adaptaDatosTablaListadoComplejo = async (datos, noColumnas, titulosTabla, columnasApi, titulosTablaComplejo, columnasApiComplejo) => {
    let tablaAdaptada = [] //tabla final a devolver para mostrar en
    let saltoPagina=false
    for (const dato of datos) {
        //salto de página
        tablaAdaptada.push(filaColSpanText(titulosTabla.length,titulosTabla.length,'',saltoPagina))
        //titulos agrupación
        tablaAdaptada.push(ponHeaderTabla(titulosTabla.length, titulosTablaComplejo, false, 0, ['fwhiteBlue', 'h4']))
        //datos agrupación
        tablaAdaptada.push(resuelveFilaComplejo(dato, columnasApiComplejo, columnasApi.length, false))
        tablaAdaptada.push(ponHeaderTabla(titulosTabla.length, titulosTabla, false))
        for (const tupla of dato.tuplas) {
            tablaAdaptada.push(resuelveFila(tupla, columnasApi))
        }
        saltoPagina=true
    }
    return tablaAdaptada
}
///-------------------------------------------------------------------------------------3.1 COMPLEJO
//FUNCIÓN PRINCIPAL TABLA DATOS TIPO LISTADO COMPLEJO
const lanzaInformeListadoComplejo = async (datos, noColumnas, ancho, porcentaje, logo) => {
    //el número de columnas lo da la longitud del array de titulosTabla
    let filas = await adaptaDatosTablaListadoComplejo(datos.datos, datos.titulosTabla.length, datos.titulosTabla, datos.columnasApi, datos.titulosComplejo.headerComplejo, datos.titulosComplejo.columnasApi)
    return {
        layout: 'headerLineOnly',
        style: ['m10', 'h5'],
        table: {
            headerRows: 0,
            widths: retornaArrayAncho(datos.titulosTabla.length, ancho, porcentaje, true), //["20%", "20%", "20%", "20%", "20%"," 20%",], //'*', 'auto', '30%'],//, 100, '*' ],
            body:
                [
                    //[{ text: '11' , colSpan: 5}, {text:''}, {text:''}, {text:''}, {text:''}],
                    
                    //filaColSpan(noColumnas,noColumnas, 'Título a poner de la comunidad', false),
                    //filaVacia(noColumnas),
                    //...header,
                    /*  [{text: 'Concepto', style: ['h5', 'fc11', 'cb']},{text: item.text, style: ['h4', 'fc2', 'b', 'c2']}],*/
                    ...filas,
                ]
        },
    }
}

///-------------------------------------------------------------------------------------4. COMPLEJO DETALLE
//FUNCION PARA ADAPTAR LOS DATOS A TABLA EN COLUMNAS DE noColumnas
const adaptaDatosTablaListadoComplejoDetalle = async (datos, noColumnas, titulosTabla, columnasApi, titulosTablaComplejo, columnasApiComplejo, titulosTablaComplejoDetalle, columnasApiComplejoDetalle, campoDetalle, saltaDePagina) => {
    let tablaAdaptada = [] //tabla final a devolver para mostrar en
    let saltoPagina=false
    
    for (const dato of datos) {
        //salto de página
        tablaAdaptada.push(filaColSpanText(titulosTabla.length,titulosTabla.length,'',saltoPagina))
        //titulos agrupación
        tablaAdaptada.push(ponHeaderTabla(titulosTabla.length, titulosTablaComplejo, false))
        //datos agrupación
        tablaAdaptada.push(resuelveFilaComplejo(dato, columnasApiComplejo, columnasApi.length, saltoPagina))
        tablaAdaptada.push(ponHeaderTabla(titulosTabla.length, titulosTabla, false))

        for (const tupla of dato.tuplas) {
            tablaAdaptada.push(resuelveFila(tupla, columnasApi,[ 'bold', 'h5']))

            //detalle
            tablaAdaptada.push(ponHeaderTabla(titulosTabla.length, titulosTablaComplejoDetalle, false, 1, ['fwhiteBlue', 'h5']))
            for (const detalle of tupla[campoDetalle]) {
                tablaAdaptada.push(resuelveFilaComplejo(detalle, columnasApiComplejoDetalle,columnasApi.length, false, 1,['cazul', 'h5']))
                
            }
            filaVacia(titulosTabla.length)

        }
        
        saltoPagina=saltaDePagina
        filaVacia(titulosTabla.length)
    }
    return tablaAdaptada
}
///-------------------------------------------------------------------------------------4.1 COMPLEJO DETALLE
//FUNCIÓN PRINCIPAL TABLA DATOS TIPO LISTADO COMPLEJO
const lanzaInformeListadoComplejoDetalle = async (datos, noColumnas, ancho, porcentaje, logo) => {
    //el número de columnas lo da la longitud del array de titulosTabla
    let filas = await adaptaDatosTablaListadoComplejoDetalle(datos.datos, datos.titulosTabla.length, datos.titulosTabla, datos.columnasApi, datos.titulosComplejo.headerComplejo, datos.titulosComplejo.columnasApi, datos.titulosComplejoDetalle.headerDetalle, datos.titulosComplejoDetalle.columnasDetalleApi,  datos.titulosComplejoDetalle.campoDetalle, datos.titulosComplejoDetalle.saltaDePagina)
    return {
        layout: 'headerLineOnly',//'lightHorizontalLines',
        style: ['m10', 'h5'],
        table: {
            headerRows: 0,
            widths: retornaArrayAncho(datos.titulosTabla.length, ancho, porcentaje, true), //["20%", "20%", "20%", "20%", "20%"," 20%",], //'*', 'auto', '30%'],//, 100, '*' ],
            body:
                [
                    //[{ text: '11' , colSpan: 5}, {text:''}, {text:''}, {text:''}, {text:''}],
                    
                    //filaColSpan(noColumnas,noColumnas, 'Título a poner de la comunidad', false),
                    //filaVacia(noColumnas),
                    //...header,
                    /*  [{text: 'Concepto', style: ['h5', 'fc11', 'cb']},{text: item.text, style: ['h4', 'fc2', 'b', 'c2']}],*/
                    ...filas,
                ]
        },
    }
}




///-------------------------------------------------------------------------------------5. INFORME DETALLE HERMANAS
//FUNCION PARA ADAPTAR LOS DATOS A TABLA EN COLUMNAS DE noColumnas
const adaptaDatosTablaListadoDetalleHermanas = async (datos, noColumnas, titulosTabla, columnasApi, titulosTablaComplejo, columnasApiComplejo, titulosTablaComplejoDetalle, columnasApiComplejoDetalle, campoDetalle, saltaDePagina) => {
    let tablaAdaptada = [] //tabla final a devolver para mostrar en
    let saltoPagina=false
    
    for (const dato of datos) {
        //salto de página
        tablaAdaptada.push(filaColSpanText(titulosTabla.length,titulosTabla.length,'',saltoPagina))
        //titulos agrupación
        tablaAdaptada.push(ponHeaderTabla(titulosTabla.length, titulosTablaComplejo, false))
        //datos agrupación
        tablaAdaptada.push(resuelveFilaComplejo(dato, columnasApiComplejo, columnasApi.length, saltoPagina))
        tablaAdaptada.push(ponHeaderTabla(titulosTabla.length, titulosTabla, false))

        for (const tupla of dato.tuplas) {
            tablaAdaptada.push(resuelveFila(tupla, columnasApi,[ 'bold', 'h5']))

            //detalle
            tablaAdaptada.push(ponHeaderTabla(titulosTabla.length, titulosTablaComplejoDetalle, false, 1, ['fwhiteBlue', 'h5']))
            for (const detalle of tupla[campoDetalle]) {
                tablaAdaptada.push(resuelveFilaComplejo(detalle, columnasApiComplejoDetalle,columnasApi.length, false, 1,['cazul', 'h5']))
                
            }
            filaVacia(titulosTabla.length)

        }
        
        saltoPagina=saltaDePagina
        filaVacia(titulosTabla.length)
    }
    return tablaAdaptada
}
///-------------------------------------------------------------------------------------5.1 INFORME DETALLE HERMANAS
//FUNCIÓN PRINCIPAL INFORME HERMANAS
const lanzaInformeDetalleHermanas = async (datos, noColumnas, ancho, porcentaje, logo) => {
    //el número de columnas lo da la longitud del array de titulosTabla
    //let filas = await adaptaDatosTablaListadoDetalleHermanas(datos.datos, datos.titulosTabla.length, datos.titulosTabla, datos.columnasApi, datos.titulosComplejo.headerComplejo, datos.titulosComplejo.columnasApi, datos.titulosComplejoDetalle.headerDetalle, datos.titulosComplejoDetalle.columnasDetalleApi,  datos.titulosComplejoDetalle.campoDetalle, datos.titulosComplejoDetalle.saltaDePagina)
    return {
        layout: 'headerLineOnly',//'lightHorizontalLines',
        style: ['m10', 'h5'],
        table: {
            headerRows: 0,
            widths: ["20%", "20%"], //retornaArrayAncho(datos.titulosTabla.length, ancho, porcentaje, true), //["20%", "20%", "20%", "20%", "20%"," 20%",], //'*', 'auto', '30%'],//, 100, '*' ],
            body:
                [
                    //[{ text: '11' , colSpan: 5}, {text:''}, {text:''}, {text:''}, {text:''}],
                    
                    //filaColSpan(noColumnas,noColumnas, 'Título a poner de la comunidad', false),
                    //filaVacia(noColumnas),
                    //...header,
                    /*  [{text: 'Concepto', style: ['h5', 'fc11', 'cb']},{text: item.text, style: ['h4', 'fc2', 'b', 'c2']}],*/
                   //...filas,
                   [{text: 'Concepto'},
                   {
                        image: 'data:image/jpeg;base64,' + datos.datos.photo,
                        fit: [100, 100],
                        //width: 150,
                        //height: 150,
                        //margin: [20, 15, 20, 10],
                        style: ['center']
                    }
                    ]
                ]
        },
    }
}